export const KA_CATEGORIES = {
  secureCoding: "secure-coding",
  coreSecurityConcepts: "core-security-concepts",
  secureDevelopment: "secure-development",
  aiLlm: "ai-llm",
};

export const categoryEstimationConfig = {
  [KA_CATEGORIES.secureCoding]: {
    questions: 10,
    estFinishTime: "15 - 25",
  },
  [KA_CATEGORIES.coreSecurityConcepts]: {
    questions: 11,
    estFinishTime: "10 - 15",
  },
  [KA_CATEGORIES.secureDevelopment]: {
    questions: 13,
    estFinishTime: "15 - 25",
  },
  [KA_CATEGORIES.aiLlm]: {
    questions: 12,
    estFinishTime: "15 - 25",
  },
};
